var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ALERTS_CATEGORIES, ALLOWED_DELIVERY_METHODS, APPROVED_TRANSACTIONS, AlertIDType, SYF_PAY_LATER } from '../../const/alertsConfig';
export var mapAttributesObjectToArray = function (alertsAttributes) {
    return Object.keys(alertsAttributes || {}).map(function (attributeKey) {
        var attributeValues = alertsAttributes[attributeKey];
        return __assign({ key: attributeKey }, attributeValues);
    });
};
export var mapDeliveryObjectToArray = function (alertsDelivery) {
    return Object.keys(alertsDelivery || {})
        .map(function (delKey) {
        var deliveryValues = alertsDelivery[delKey];
        return __assign({ key: delKey }, deliveryValues);
    })
        .map(function (delMeth) {
        return __assign({}, delMeth);
    })
        .sort(function (a, b) {
        var aIndex = ALLOWED_DELIVERY_METHODS.indexOf(a.key);
        var bIndex = ALLOWED_DELIVERY_METHODS.indexOf(b.key);
        // Not found, put at end
        if (aIndex === -1) {
            return 1;
        }
        return aIndex - bIndex;
    });
};
export var getIsAlertOn = function (deliveryMethods) {
    return deliveryMethods.some(function (deliveryMethod) { return deliveryMethod.enrolled; });
};
export var getCategoryId = function (alertID) {
    return (Object.keys(ALERTS_CATEGORIES).filter(function (categoryKey) {
        return ALERTS_CATEGORIES[categoryKey].includes(alertID);
    })[0] || 'uncategorized');
};
export var isApprovedTransactionsCreated = function (list) {
    var allAlertsIds = list.map(function (item) { return item.id; });
    return APPROVED_TRANSACTIONS.every(function (alert) { return allAlertsIds.indexOf(alert) !== -1; });
};
export var isPayLaterCreated = function (list) {
    var allAlertsIds = list.map(function (item) { return item.id; });
    return SYF_PAY_LATER.every(function (alert) { return allAlertsIds.indexOf(alert) !== -1; });
};
export var isAlertTurnedOn = function (preference) {
    return !!Object.values(preference.delivery).find(function (d) { return d.enrolled; });
};
export var getApprovedTransactionPreference = function (preferences) {
    // assume that only one of TRANSACTION_AUTHORIZATION, PURCHASE_EXCEEDS can be turned on
    var approvedTransactionPreference = preferences.find(function (preference) {
        return APPROVED_TRANSACTIONS.indexOf(preference.id) !== -1 &&
            isAlertTurnedOn(preference);
    });
    if (approvedTransactionPreference) {
        return {
            id: AlertIDType.APPROVED_TRANSACTIONS,
            delivery: approvedTransactionPreference.delivery,
            attributes: {
                approvedTransactionType: { value: approvedTransactionPreference.id }
            }
        };
    }
    return {
        id: AlertIDType.APPROVED_TRANSACTIONS,
        delivery: {
            email: { enrolled: false, changeable: true },
            text: { enrolled: false, changeable: true }
        },
        attributes: { approvedTransactionType: { value: '' } }
    };
};
export var getPayLaterPreference = function (preferences) {
    var syfPayLaterPreference = preferences.find(function (preference) { return SYF_PAY_LATER.indexOf(preference.id) !== -1; });
    return {
        id: AlertIDType.SYF_PAY_LATER,
        delivery: syfPayLaterPreference.delivery
    };
};
